<ng-container [ngSwitch]="selectedOptionName">
  <lib-web-theme *ngSwitchCase="sideNavOptions.theme"></lib-web-theme>
  <lib-web-pages  *ngSwitchCase="sideNavOptions.pages"></lib-web-pages>
  <lib-web-entity *ngSwitchCase="sideNavOptions.entity"></lib-web-entity>
  <lib-api-calls  *ngSwitchCase="sideNavOptions.api"></lib-api-calls>
  <lib-web-settings *ngSwitchCase="sideNavOptions.settings"></lib-web-settings>
  <lib-web-analytics *ngSwitchCase="sideNavOptions.metrics"></lib-web-analytics>
  <div *ngSwitchDefault>
    Content for {{ selectedOptionName }} option goes here.
  </div>
</ng-container>
